var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col-6"},[_c('ColorOption',{on:{"input":function($event){return _vm.$emit('change')}},model:{value:(_vm.settings.color),callback:function ($$v) {_vm.$set(_vm.settings, "color", $$v)},expression:"settings.color"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-5"},[_c('small',[_vm._v("Color:")])])
}]

export { render, staticRenderFns }